/* unplugin-vue-components disabled */import { render } from "./CButton.vue?vue&type=template&id=1515a3c8&scoped=true&ts=true"
import script from "./CButton.vue?vue&type=script&lang=ts"
export * from "./CButton.vue?vue&type=script&lang=ts"

import "./CButton.vue?vue&type=style&index=0&id=1515a3c8&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1515a3c8"]])

export default __exports__